import React, { useState, useEffect } from 'react';
import axios from 'axios';
import GenericFileDownload from '../GenericFileDownload';

const GenericTextFileViewer = ({ fileUrl, onLoad, item }) => {
  const [fileContent, setFileContent] = useState('');

  useEffect(() => {
    if (!fileUrl) return;

    axios(fileUrl)
      .then((res) => {
        setFileContent(JSON.stringify(res.data));
        typeof onLoad === 'function' && onLoad();
      })
      .catch((error) => console.error('Error loading .txt file:', error));
  }, [fileUrl, onLoad]);

  if (!fileUrl) return null;

  return (
    <div className="txt-file-viewer h-100 w-100 d-flex flex-column align-items-center">
      {item && <GenericFileDownload file={item} iconClassName="icon-save p-2 pointer float-end h2 mb-0" />}
      <div className="w-100 d-flex justify-content-center">
        <pre className="text-center">{fileContent}</pre>
      </div>
    </div>
  );
};

export default GenericTextFileViewer;
